/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import templateOnly from '@ember/component/template-only';

interface IArgs {
  isChecked: boolean;

  label: string;

  offLabel?: string;
  onLabel?: string;

  isDisabled?: boolean;

  onClick(): void;
}

interface UiToggleComponentSignature {
  Element: HTMLSpanElement;

  Args: IArgs;
}

const UiToggleComponent = templateOnly<UiToggleComponentSignature>();

export default UiToggleComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Ui::Toggle': typeof UiToggleComponent;
  }
}
